import qs from 'qs'
import AuthService from '@/packages/auth-service'
import store from '@/app/store'
import b2bApiClient from '@/shared/api/b2b-client'

export class InvoicesService {
  constructor() {
    this.client = b2bApiClient.getClient()
  }

  get _accessToken() {
    return store.state.auth.access_token || AuthService.getAccessToken()
  }

  get _headers() {
    return {
      'Content-Type': 'application/json',
      'x-access-token': this._accessToken,
    }
  }

  createInvoice(formData) {
    return this.client.post('/processing/partner/invoices', formData, {
      headers: this._headers,
    })
  }

  getInvoices(params) {
    return this.client.client.get('/processing/partner/invoices', {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      },
      headers: this._headers,
    })
  }

  getInvoiceById(invoiceId, sortParams = {}) {
    return this.client.client.get(`/processing/partner/invoices/${invoiceId}`, {
      params: {
        ...sortParams,
      },
      headers: this._headers,
    })
  }

  cancelInvoice(invoiceId) {
    return this.client.client.patch(
      `/processing/partner/invoices/${invoiceId}/cancel`,
      {},
      {
        headers: this._headers,
      }
    )
  }

  downloadInvoice(invoiceId, language = 'ru') {
    return this.client.client.get(
      `/processing/partner/invoices/${invoiceId}/download`,
      {
        params: {
          language: language,
        },
        headers: this._headers,
        responseType: 'blob',
      }
    )
  }

  getInvoiceLink(invoiceId, language = 'ru') {
    return this.client.client.get(
      `/processing/partner/invoices/${invoiceId}/link`,
      {
        params: {
          language: language,
        },
        headers: this._headers,
      }
    )
  }

  getInvoiceCustomization() {
    return this.client.client.get(
      '/processing/partner/invoices/customization',
      {
        headers: this._headers,
      }
    )
  }

  upsertInvoiceCustomization(data) {
    return this.client.post(
      '/processing/partner/invoices/customization',
      data,
      {
        headers: this._headers,
      }
    )
  }

  uploadInvoiceLogo(file) {
    const formData = new FormData()
    formData.append('file', file)

    return this.client.client.post(
      '/processing/partner/invoices/customization/logo',
      formData,
      {
        headers: {
          ...this._headers,
          'Content-Type': 'multipart/form-data',
        },
      }
    )
  }

  deleteInvoiceLogo() {
    return this.client.client.delete(
      '/processing/partner/invoices/customization/logo',
      {
        headers: this._headers,
      }
    )
  }
}

export const invoicesService = new InvoicesService()
export default invoicesService
